import styled from "styled-components"

import { colors, spacing, Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import LightBulbIcon from "src/ui/icons/lightbulb-on.svg"
import { MCard } from "src/ui/MCard/MCard"

export function PortfolioAnalyticsTipsCard() {
  const { tPlaceholder } = useTranslate()

  return (
    <MCard
      boxShadow={false}
      border={false}
      backgroundColor={colors.primaryLight}
      padding={spacing.L}
    >
      <Box>
        <div>
          <SubtitleContainer>
            <LightBulbIcon width={24} height={24} />
            <Text variant="subtitle">
              {tPlaceholder("How to improve unit coverage & reliability")}
            </Text>
          </SubtitleContainer>

          <Text variant="bodyS">
            <li>
              {tPlaceholder(
                "Check battery levels often. Replace or charge devices with low battery to keep them online."
              )}
            </li>
          </Text>
          <Text variant="bodyS">
            <li>
              {tPlaceholder(
                "Keep devices away from signal blockers. Avoid placing them near metal surfaces, microwaves, or thick concrete walls."
              )}
            </li>
          </Text>
          <Text variant="bodyS">
            <li>
              {tPlaceholder(
                "Sync your PMS regularly. This ensures any new units are added and monitored automatically."
              )}
            </li>
          </Text>
        </div>
      </Box>
    </MCard>
  )
}

const Box = styled.div`
  display: grid;
  gap: ${spacing.M};
  grid-template-columns: 1fr auto;
  align-items: center;
`

const SubtitleContainer = styled.div`
  display: flex;
  gap: ${spacing.XS};
`
